var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ParentBar'),_c('PermissionValidation',{attrs:{"marketId":_vm.marketId,"rule":"enableViewCustomers"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }